import React, { useState } from "react";
import axios from "axios";
import firebase from "../../util/firebaseConfig";
import { useSelector } from "react-redux";
import TeamItem from "../layout/Items/TeamItem";
import alertify from "alertifyjs";
import {
  Button,
  Divider,
  Header,
  Input,
  Message,
  Modal,
  Table,
} from "semantic-ui-react";

function MemberAddModal() {
  const db = firebase.firestore();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");

  const uid = useSelector((state) => state.firebase.auth.uid);
  const ownerMail = useSelector((state) => state.firebase.auth.email);

  const handleSubmit = (e) => {
    e.preventDefault();
    // global.alert(uid);
    const memberArray = [];
    db.collection("members")
      .get()
      .then((snap) => {
        snap.forEach((doc) => {
          const key = doc.data().receiver;
          if (key === email) {
            memberArray.push({
              receiver: email,
              sender: ownerMail,
              senderId: uid,
            });
          }
        });

        if (memberArray.length === 0) {
          db.collection("members")
            .add({
              receiver: email,
              sender: ownerMail,
              senderId: uid,
              createdAt: new Date(),
            })
            .then(() => {
              axios
                .post(
                  "https://europe-west1-omnes-immigration-app.cloudfunctions.net/api/mail/member",
                  { mail: email }
                )
                .catch((err) => {
                  console.log(err);
                });

              alertify.success(
                `The invitation link has been successfully sent to the ${email} address.`
              );
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          alertify.error(
            `The ${email} address you want to send an invitation to is registered in the system.`
          );
        }
      });
  };

  return (
    <Modal
      centered={false}
      size="small"
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      trigger={
        <Button
          fluid
          content="Add a New Member"
          icon="add user"
          labelPosition="left"
        />
      }
    >
      <Modal.Header>Add a New Team Member</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Message>
            Please enter the email address of the user you want to add.
          </Message>
          <Divider />
          <Message style={{ display: "flex" }}>
            <Input
              onChange={(e) => setEmail(e && e.target && e.target.value)}
              placeholder="E-mail"
              size="big"
              fluid
              style={{ width: "100%" }}
            />
            <Button size="big" onClick={handleSubmit}>
              SEND
            </Button>
          </Message>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setOpen(false)}>CANCEL</Button>
      </Modal.Actions>
    </Modal>
  );
}
const AddMember = () => {
  return (
    <Table fixed>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan="3">
            {" "}
            <Header>Team Sections</Header>
            <MemberAddModal />
          </Table.HeaderCell>
        </Table.Row>
        <Table.Body>
          <TeamItem />
        </Table.Body>
      </Table.Header>
    </Table>
  );
};

export default AddMember;
